import { getHeight } from "./utils";

// Calculate the view factor of the facades to the street
export const calcVF_perpendicular_ftos = (
  cellId,
  curCellIndex,
  cellParams,
  nCells,
  cellWidth,
  streetWidth,
) => {
  const base = 0;
  const streetLength = cellWidth * nCells;
  const x = [base, getHeight(cellParams, cellId)];
  // const x = [0.01, getHeight(cellParams, cellId)];
  const y = [curCellIndex * cellWidth, (curCellIndex + 1) * cellWidth];
  const xi = [base, streetWidth];
  // const xi = [0.01, streetWidth];
  const eta = [base, streetLength];

  const f = Perp(x, y, xi, eta);

  return f;
};

const Perp = (x, y, xi, eta) => {
  let i, j, k, l;
  let f = 0.0;
  for (l = 0; l < 2; l++) {
    for (k = 0; k < 2; k++) {
      for (j = 0; j < 2; j++) {
        for (i = 0; i < 2; i++) {
          f =
            f +
            Math.pow(-1, i + j + k + l) *
              calcVF_perpendicular_G(x[i], y[j], eta[k], xi[l]);
        }
      }
    }
  }

  f = f / ((x[1] - x[0]) * (y[1] - y[0]));

  return f;
};

// Calculate the view factor of the street to the facades
export const calcVF_perpendicular_stof = (
  cellId,
  curCellIndex,
  cellParams,
  nCells,
  cellWidth,
  streetWidth,
) => {
  const base = 0;
  const streetLength = cellWidth * nCells;
  const x = [base, streetWidth];
  // const x = [0.01, streetWidth];
  const y = [base, streetLength];
  const xi = [base, getHeight(cellParams, cellId)];
  // const xi = [0.01, getHeight(cellParams, cellId)];
  const eta = [curCellIndex * cellWidth, (curCellIndex + 1) * cellWidth];

  const f = Perp(y, x, eta, xi);

  return f;
};

export const calcVF_perpendicular_G = (x, y, eta, xi) => {
  const eps = 1.0e-10;

  if (eta === y) {
    y = y + eps;
  }

  let x_xi = Math.sqrt(x * x + xi * xi);

  if (x_xi < eps) {
    x_xi = eps;
  }

  let K = (y - eta) / x_xi;

  let g = (y - eta) * x_xi * Math.atan(K);
  g -=
    0.25 *
    ((x * x + xi * xi) * Math.log(1 + K * K) -
      (y - eta) * (y - eta) * Math.log(1 + 1 / (K * K)));
  g = g / (2 * Math.PI);

  return g;
};

export const calcVF_parallel = (
  oppCellIndex,
  curCellIndex,
  cellId,
  oppCellId,
  cellParams,
  cellWidth,
  streetWidth,
) => {
  const base = 0;
  const x = [base, getHeight(cellParams, cellId)];
  const y = [curCellIndex * cellWidth, (curCellIndex + 1) * cellWidth];
  const xi = [base, getHeight(cellParams, oppCellId)];
  const eta = [oppCellIndex * cellWidth, (oppCellIndex + 1) * cellWidth];
  let i, j, k, l;
  let f = 0.0;
  for (i = 0; i < 2; i++) {
    for (j = 0; j < 2; j++) {
      for (k = 0; k < 2; k++) {
        for (l = 0; l < 2; l++) {
          f =
            f +
            Math.pow(-1, i + j + k + l) *
              VF_parallel_G(x[i], y[j], streetWidth, eta[k], xi[l]);
        }
      }
    }
  }
  const c = 1 / ((x[1] - x[0]) * (y[1] - y[0]));

  return c * f;
};

export const VF_parallel_G = (x, y, z, eta, xi) => {
  return (
    (((y - eta) *
      (Math.pow((Math.pow(x - xi), 2) + Math.pow(z, 2)), 0.5) *
      Math.atan(
        (y - eta) / (Math.pow((Math.pow(x - xi), 2) + Math.pow(z, 2)), 0.5),
      ) +
      (x - xi) *
        (Math.pow((Math.pow(y - eta), 2) + Math.pow(z, 2)), 0.5) *
        Math.atan(
          (x - xi) / (Math.pow((Math.pow(y - eta), 2) + Math.pow(z, 2)), 0.5),
        ) -
      (Math.pow(z, 2) / 2) *
        Math.log(Math.pow(x - xi, 2) + Math.pow(y - eta, 2) + Math.pow(z, 2))) /
      2) *
    Math.PI
  );
};
